import React from 'react';
import './TokmaDana.css'
import tokmadana from '../TokmaDana/Image/tokma dana.png'

const TokmaDana = () => {
    return (
        <div>
            <section className='hero-tukma'>
                <div style={{ width: '100%', height: '100%' }}>
                    <img src={tokmadana} alt="" style={{ width: '100%', height: '100%' }} />
                </div>
            </section>
            <h1 style={{textAlign:'center'}}>Website under processing.... plz wait untill to complete</h1>
        </div>
    );
};

export default TokmaDana;